import {
  TypeOfApplicationLink,
} from '@kaltura-ott/tvpil/interfaces/meta';
import { RhinoLinkType } from '@kaltura-ott/tvpil-shared/lib/rhino/data/type';

import { FROM_REFERENCE_ID } from 'consts';
import routes from 'routesPaths';

interface Props {
  linkType?: RhinoLinkType;
  inAppLink: string;
  subtype?: string;
  dataLink?: string;
  id?: number | string;
  referenceId?: any;
}

export function getGridPageLink ({
  linkType,
  inAppLink,
  subtype,
  id,
  referenceId,
  dataLink,
}: Props): string {
  switch(linkType) {
    case TypeOfApplicationLink.grid:
      return routes.grid.link(`/${TypeOfApplicationLink.grid}/${subtype}/${inAppLink}/${id}?${FROM_REFERENCE_ID}=${referenceId}`);
    case TypeOfApplicationLink.page:
    case TypeOfApplicationLink.asset:
      return `${dataLink}${referenceId ? `?${FROM_REFERENCE_ID}=${referenceId}` : ''}`;
    case TypeOfApplicationLink.external:
      return inAppLink;
    default:
      console.warn('linkType is not defined', linkType);
      return inAppLink;
  }
}
